import { render, staticRenderFns } from "./ScreeningProcessCrime.vue?vue&type=template&id=a77b133a&scoped=true&"
import script from "./ScreeningProcessCrime.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessCrime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77b133a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a77b133a')) {
      api.createRecord('a77b133a', component.options)
    } else {
      api.reload('a77b133a', component.options)
    }
    module.hot.accept("./ScreeningProcessCrime.vue?vue&type=template&id=a77b133a&scoped=true&", function () {
      api.rerender('a77b133a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/ScreeningProcessCrime.vue"
export default component.exports